import { normalizeBasecampHtml } from '@/lib/basecamp-html'

export type BasecampNotesDraftStatus = 'pending' | 'pushed' | 'dismissed'

export type BasecampNotesDraft = {
  todoId: string
  html: string
  todoUrl: string
  title?: string
  status?: BasecampNotesDraftStatus
}

const STORAGE_PREFIX = 'flownotes_basecamp_notes_draft:'

function asRecord(value: unknown): Record<string, unknown> | null {
  return value && typeof value === 'object' ? (value as Record<string, unknown>) : null
}

function optionalString(value: unknown): string | undefined {
  if (value == null) return undefined
  const text = String(value).trim()
  return text ? text : undefined
}

function parseStatus(value: unknown): BasecampNotesDraftStatus | undefined {
  if (value === 'pending' || value === 'pushed' || value === 'dismissed') return value
  return undefined
}

export function parseProposedBasecampNotesEvent(
  parsed: Record<string, unknown>,
): BasecampNotesDraft | null {
  const todoId = optionalString(parsed.todoId)
  const html = optionalString(parsed.html)
  const todoUrl = optionalString(parsed.todoUrl)
  if (!todoId || !html || !todoUrl) return null
  return {
    todoId,
    html: normalizeBasecampHtml(html),
    todoUrl,
    title: optionalString(parsed.title),
    status: parseStatus(parsed.status) || 'pending',
  }
}

export function persistBasecampNotesOutcome(
  conversationId: string | null | undefined,
  draft: BasecampNotesDraft,
): void {
  if (!conversationId || !draft.status || draft.status === 'pending') return
  try {
    sessionStorage.setItem(
      `${STORAGE_PREFIX}${conversationId}:outcome:${draft.todoId}`,
      JSON.stringify({ status: draft.status }),
    )
  } catch {
    /* ignore */
  }
}

export function applyBasecampNotesOutcome(
  conversationId: string | null | undefined,
  draft: BasecampNotesDraft,
): BasecampNotesDraft {
  if (!conversationId) return draft
  try {
    const raw = sessionStorage.getItem(`${STORAGE_PREFIX}${conversationId}:outcome:${draft.todoId}`)
    if (!raw) return draft
    const parsed = asRecord(JSON.parse(raw))
    const status = parseStatus(parsed?.status)
    return status ? { ...draft, status } : draft
  } catch {
    return draft
  }
}
